import { useEffect, useState } from "react";
import api from "../lib/api";
import { fmtNum, fmtUsd, fmtVol, fmtTime } from "../lib/format";
import { Search, Hourglass, Ban, Globe } from "lucide-react";

const SIG_STATUS = {
  pending: ["Bekliyor (tetik izleniyor)", "text-[#F59E0B]"], triggered: ["Tetiklendi", "text-[#3B82F6]"],
  filled: ["Gerçekleşti", "text-[#10B981]"], expired: ["Süresi doldu", "text-[#64748B]"],
  skipped: ["Atlandı", "text-[#EF4444]"], cancelled: ["İptal", "text-[#64748B]"],
};

export default function V2ScannerView({ p = "v2" }) {
  const [uni, setUni] = useState([]);
  const [sigs, setSigs] = useState([]);
  const [skips, setSkips] = useState([]);
  const [stage, setStage] = useState("");

  const load = () => {
    api.get(`/${p}/universe`).then((r) => setUni(r.data)).catch(() => {});
    api.get(`/${p}/signals?limit=60`).then((r) => setSigs(r.data)).catch(() => {});
    api.get(`/${p}/skips?limit=120${stage ? `&stage=${stage}` : ""}`).then((r) => setSkips(r.data)).catch(() => {});
  };
  useEffect(() => { load(); const i = setInterval(load, 5000); return () => clearInterval(i); }, [stage]); // eslint-disable-line react-hooks/exhaustive-deps

  const pending = sigs.filter((s) => s.status === "pending");
  return (
    <div className="space-y-5 fade-up">
      <div>
        <h2 className="font-head text-xl font-bold flex items-center gap-2"><Search className="h-5 w-5 text-[#3B82F6]" /> Piyasa Tarayıcı — {p === "v3" ? "bot (RSI)" : "V2"}</h2>
        <p className="text-xs text-[#64748B] mt-1">
          Evren: 24s USDT hacmi en yüksek 20 sürekli sözleşme (15 dk'da bir). Hacim yalnızca seçim içindir. {p === "v3" ? "Aday: 5m Wilder RSI (ayarlardaki periyot) ≤ alt eşik → LONG, ≥ üst eşik → SHORT (her mum kapanışında yenilenir); slot boşalınca eşikten en uzak RSI'lı aday önce açılır. Çıkış: yalnızca net ROI hedefi; stop yok; eşik ROI'de ekleme." : "Sinyal: 15m trend (kapanış/EMA20/EMA50 + EMA20 eğimi) + 5m EMA20'ye geri çekilme; tetik sonraki 5m mum boyunca geçerli."}
          Demo hacmi/likiditesi canlı piyasayı temsil etmeyebilir.
        </p>
      </div>

      <section className="bg-[#121724] border border-[#1E2738] rounded-lg p-4">
        <h3 className="text-sm font-bold text-[#F59E0B] flex items-center gap-2 mb-3"><Hourglass className="h-4 w-4" /> Bekleyen Girişler ({pending.length})</h3>
        <div data-testid="pending-signals-list" className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
          {pending.length === 0 && <div className="text-xs text-[#64748B]">Şu an bekleyen sinyal yok.</div>}
          {pending.map((s) => (
            <div key={s.signal_id} data-testid={`pending-signal-${s.symbol}`} className="border border-[#1E2738] rounded-md p-3 font-mono text-xs space-y-1">
              <div className="flex justify-between"><b className="text-[#F1F5F9]">{s.symbol}</b><span className={s.direction === "LONG" ? "text-[#10B981]" : "text-[#EF4444]"}>{s.direction}</span></div>
              {p === "v3" ? <div className="text-[#94A3B8]">RSI: {Number(s.rsi_cur).toFixed(1)} · Ref: {fmtNum(s.ref_price, 6)} · Sıra #{s.queue_pos}</div> : <div className="text-[#94A3B8]">Tetik: {fmtNum(s.trigger_price, 6)} · Son: {fmtNum(s.last_price, 6)}</div>}
              {p !== "v3" && <div className="text-[#94A3B8]">Stop: {fmtNum(s.stop_price, 6)} · ATR: {fmtNum(s.atr, 6)}</div>}
              <div className="text-[#64748B]">Oluşma: {fmtTime(s.created_at)} · Kalan: {s.remaining_sec}s</div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#121724] border border-[#1E2738] rounded-lg overflow-hidden">
        <div className="px-4 py-3 border-b border-[#1E2738] text-sm font-bold flex items-center gap-2"><Globe className="h-4 w-4 text-[#3B82F6]" /> Evren (ilk 20)</div>
        <div className="overflow-x-auto">
          <table data-testid="universe-table" className="w-full text-xs min-w-[520px]">
            <thead><tr className="text-[10px] uppercase text-[#64748B] border-b border-[#1E2738]">
              <th className="text-left px-4 py-2">Sembol</th><th className="text-right px-4 py-2">24s Hacim</th><th className="text-right px-4 py-2">Tick</th><th className="text-right px-4 py-2">Maks Kaldıraç</th><th className="text-left px-4 py-2">Güncellendi</th></tr></thead>
            <tbody>{uni.map((u) => (
              <tr key={u.symbol} className="border-b border-[#1E2738]/60 font-mono">
                <td className="px-4 py-1.5 font-semibold">{u.symbol}</td><td className="px-4 py-1.5 text-right text-[#94A3B8]">{fmtVol(u.quote_volume)}</td>
                <td className="px-4 py-1.5 text-right text-[#64748B]">{u.tick}</td><td className="px-4 py-1.5 text-right text-[#64748B]">{u.max_leverage ? `${u.max_leverage}x` : "—"}</td>
                <td className="px-4 py-1.5 text-[#64748B]">{fmtTime(u.updated_at)}</td></tr>))}</tbody>
          </table>
        </div>
      </section>

      <section className="bg-[#121724] border border-[#1E2738] rounded-lg overflow-hidden">
        <div className="px-4 py-3 border-b border-[#1E2738] text-sm font-bold">Son Sinyaller</div>
        <div className="overflow-x-auto">
          <table data-testid="signals-table" className="w-full text-xs min-w-[720px]">
            <thead><tr className="text-[10px] uppercase text-[#64748B] border-b border-[#1E2738]">
              <th className="text-left px-4 py-2">Zaman</th><th className="text-left px-4 py-2">Sembol</th><th className="text-left px-4 py-2">Yön</th><th className="text-right px-4 py-2">{p === "v3" ? "RSI önceki→güncel" : "Tetik"}</th><th className="text-right px-4 py-2">Stop</th><th className="text-left px-4 py-2">Durum</th><th className="text-left px-4 py-2">Açıklama</th></tr></thead>
            <tbody>
              {sigs.length === 0 && <tr><td colSpan={7} className="text-center text-[#64748B] py-6">Henüz sinyal yok.</td></tr>}
              {sigs.map((s) => { const [t, c] = SIG_STATUS[s.status] || [s.status, ""]; return (
                <tr key={s.signal_id} className="border-b border-[#1E2738]/60 font-mono">
                  <td className="px-4 py-1.5 text-[#64748B]">{fmtTime(s.created_at)}</td><td className="px-4 py-1.5 font-semibold">{s.symbol}</td>
                  <td className={`px-4 py-1.5 ${s.direction === "LONG" ? "text-[#10B981]" : "text-[#EF4444]"}`}>{s.direction}</td>
                  <td className="px-4 py-1.5 text-right">{p === "v3" ? Number(s.rsi_cur).toFixed(1) : fmtNum(s.trigger_price, 6)}</td><td className="px-4 py-1.5 text-right">{p === "v3" ? "—" : fmtNum(s.stop_price, 6)}</td>
                  <td className={`px-4 py-1.5 ${c}`}>{t}</td><td className="px-4 py-1.5 text-[#94A3B8] max-w-[320px] truncate" title={s.skip_reason}>{s.skip_reason || "—"}</td></tr>); })}
            </tbody>
          </table>
        </div>
      </section>

      <section className="bg-[#121724] border border-[#1E2738] rounded-lg overflow-hidden">
        <div className="px-4 py-3 border-b border-[#1E2738] text-sm font-bold flex items-center justify-between gap-2 flex-wrap">
          <span className="flex items-center gap-2"><Ban className="h-4 w-4 text-[#EF4444]" /> Atlanan İşlem Gerekçeleri</span>
          <select data-testid="skip-stage-filter" value={stage} onChange={(e) => setStage(e.target.value)} className="bg-[#0B0E17] border border-[#1E2738] rounded px-2 py-1 text-xs">
            <option value="">Tümü</option>{p !== "v3" && <option value="trend">15m trend</option>}<option value="signal">5m sinyal</option><option value="entry">Giriş/filtre</option>
          </select>
        </div>
        <div data-testid="skips-table" className="max-h-80 overflow-y-auto divide-y divide-[#1E2738]/60">
          {skips.length === 0 && <div className="text-center text-[#64748B] py-6 text-xs">Kayıt yok.</div>}
          {skips.map((k, i) => (
            <div key={i} className="px-4 py-1.5 text-xs font-mono flex gap-3">
              <span className="text-[#64748B] shrink-0">{fmtTime(k.ts)}</span><span className="font-semibold shrink-0 w-24">{k.symbol}</span>
              <span className="text-[#64748B] shrink-0 w-14">{k.stage}</span><span className="text-[#94A3B8]">{k.reason}</span>
            </div>))}
        </div>
      </section>
      <p className="text-[11px] text-[#64748B]">Not: Hedef {fmtUsd(1.5)} USDT gibi küçük net hedeflerde maliyet/ATR filtreleri çoğu adayı eler; gerekçeler yukarıda kayıt altındadır.</p>
    </div>
  );
}
